import currency from 'currency.js'
import dayjs from 'dayjs'

/**
 * 格式化金额 (支持千分符与小数位)
 * @param val 金额数值或字符串
 * @param precision 保留小数位数，默认 2 位
 * @returns 格式化后的金额字符串（如 "1,200.00"），空值返回 ""
 */
export function formatCurrency(val: any, precision: number = 2): string {
  if (val === null || val === undefined || val === '') {
    return ''
  }
  const num = Number(val)
  if (Number.isNaN(num)) {
    return String(val)
  }
  return currency(val, { precision, symbol: '' }).format()
}

/**
 * 格式化税率
 * @param val 单一税率值、带%字符串、或税率数组
 * @returns 格式化后的税率（如 "13%" 或 "6%，13%"）
 */
export function formatTaxRate(val: any): string {
  if (val === null || val === undefined || val === '') {
    return '0%'
  }
  if (Array.isArray(val)) {
    if (val.length === 0) return '0%'
    return val
      .map((k: any) => {
        const s = String(k).trim()
        return s.endsWith('%') ? s : `${s}%`
      })
      .join('，')
  }
  const str = String(val).trim()
  return str.endsWith('%') ? str : `${str}%`
}

/**
 * 格式化布尔/是否标签
 * @param val 判定值 (boolean, 1/0, "是"/"否")
 * @param trueText 值为真时的文案，默认为 "是"
 * @param falseText 值为假时的文案，默认为 "否"
 */
export function formatBoolean(val: any, trueText: string = '是', falseText: string = '否'): string {
  if (val === true || val === 1 || val === '1' || val === trueText) {
    return trueText
  }
  if (val === false || val === 0 || val === '0' || val === falseText) {
    return falseText
  }
  return val ? trueText : falseText
}

/**
 * 格式化费用通用数值或比率字符串
 * @param val 数值或字符串
 */
export function formatFee(val: any): string {
  if (val === null || val === undefined) {
    return ''
  }
  return String(val).trim()
}

/**
 * 格式化日期时间
 * @param val 日期字符串、时间戳或 Date 对象
 * @param formatPattern 日期格式，默认 'YYYY-MM-DD HH:mm:ss'
 */
export function formatDate(val: any, formatPattern: string = 'YYYY-MM-DD HH:mm:ss'): string {
  if (!val) {
    return ''
  }
  const d = dayjs(val)
  return d.isValid() ? d.format(formatPattern) : String(val)
}
